<template>
  <div>
    <p class="mb-10"><strong class="fs-12">Podřízený spolupracovník</strong></p>
    <div class="collaborator-overflow" v-for="n in items">
      <div class="collaborator-item" :class="{'collaborator-item_deleted' : n.smazano == 1}">
        <v-btn color="primary" icon outline small @click="n.detail=!n.detail" v-if="n.spolupracovnici.length>0"><v-icon v-if="!n.detail">add</v-icon><v-icon v-else>remove</v-icon></v-btn>
        <!-- <img src="@/assets/images/logo.svg" alt="Jméno a příjmení"> -->
        <span :class="{ 'ml-3': n.spolupracovnici.length > 0, 'ml-4 pl-2': n.spolupracovnici.length == 0 }">{{n.nazev_osoby}}
          <v-icon v-if="n.smazano" class="text-red ml-1" color="red" small>highlight_off</v-icon>
        </span>
        <span v-if="n.info">Certifikace
          <v-icon class="text-green ml-1" color="green" small v-if="n.certifikovan">check_circle_outline</v-icon>
          <v-icon class="text-red ml-1" color="red" small v-else>highlight_off</v-icon>
        </span>
        <span v-if="n.info">Pozice: {{n.pozice}}</span>
        <span v-if="n.info">Vlastní: {{n.vlastni_kredity | formatInt}} kr.</span>
        <span v-if="n.info">Strukturní: {{n.skupinove_kredity | formatInt}} kr</span>
        <span v-if="n.info">Celkem: {{n.celkem_kredity | formatInt}} kr</span>
        <!-- <v-btn color="primary" class="elevation-0 bold ma-0" small dark><v-icon>remove_red_eyes</v-icon> Detail</v-btn> -->
      </div>
      <div class="collaborator-item__sub" v-if="n.spolupracovnici.length>0 && n.detail">
        <spolupracovnici-podrizeni :items="n.spolupracovnici"></spolupracovnici-podrizeni>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        detail: false
      };
    },
    props: {
      items: Array
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/SpolupracovniciPodrizeni.vue